/**
 * Returns true when the app was backgrounded long enough to warrant a forced data refresh.
 */
export function shouldForceRefreshAfterIdle(
  lastBackgroundAt: number | null,
  now: number,
  thresholdMs: number,
): boolean {
  if (lastBackgroundAt === null) return false;
  return now - lastBackgroundAt >= thresholdMs;
}
